import { useEffect, useState } from 'react';
import { formatBalance } from '@ui/src';
import { OrganizationType } from '../../../hoc/common/types';
import Card from '../card/card';
import { SummaryInfoTypes } from './types';

import cn from './styles.module.css';

const SummaryInfo = ({
  accounts,
  currencies,
  balance,
  type = OrganizationType.INDIVIDUAL,
  cardsEnabled,
  balances,
  currenciesList,
  dictionariesCurrencies,
  baseCurrency,
}: SummaryInfoTypes): React.JSX.Element => {
  const [availableCurrencies, setAvailableCurrencies] = useState<
    {
      id: string;
      name: string;
    }[]
  >([]);

  useEffect(() => {
    if (balances && currenciesList) {
      const currenciesArray: { id: string; name: string }[] = [];

      currenciesList?.forEach((item) => {
        if (
          balances?.find((balanceItem) => balanceItem.currencyId === item.value)
        ) {
          currenciesArray.push({
            id: item.value as string,
            name: item?.suffix || '',
          });
        }
      });

      setAvailableCurrencies(currenciesArray);
    }
  }, [balances, currenciesList]);

  return (
    <Card>
      <div className={cn.summaryWrapper}>
        {type !== OrganizationType.COMPANY_OFFICIAL && cardsEnabled && (
          <div className={cn.summaryItem}>
            <div className={cn.summaryItemTitle}>Cards</div>
            <div className={cn.summaryItemValue}>-</div>
          </div>
        )}
        <div className={cn.summaryItem}>
          <div className={cn.summaryItemTitle}>Accounts</div>
          <div className={cn.summaryItemValue}>{accounts}</div>
        </div>
        <div className={cn.summaryItem} style={{ borderRight: 'none' }}>
          <div className={cn.summaryItemTitle}>Currencies</div>
          <div className={cn.summaryItemValue}>
            {currencies ? currencies?.length : '-'}
            <div className={cn.summaryItemCurrencies}>
              {availableCurrencies
                ?.map((item) => item.name.toUpperCase())
                .join(' ')}
            </div>
          </div>
        </div>
        {type !== OrganizationType.COMPANY_OFFICIAL && (
          <div className={cn.summaryItem} style={{ display: 'none' }}>
            <div className={cn.summaryItemTitle}>Balance</div>
            <div className={cn.summaryItemValue}>
              {balance &&
                formatBalance(
                  balance,
                  dictionariesCurrencies?.find(
                    (item) => item.id === baseCurrency?.id,
                  ),
                )}
              {balance !== undefined && (
                <div className={cn.summaryItemBalanceCurrency}>
                  {baseCurrency?.name}
                </div>
              )}
              <div className={cn.summaryItemBalanceHint}>BC</div>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default SummaryInfo;
